<template>
  <div class="mod-shops">
    <el-form
      :inline="true"
      :model="searchForm"
      @keyup.enter.native="getDataList()"
    >
      <el-form-item>
        <el-input v-model="searchForm.name" placeholder="冷柜名字" clearable />
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()"> 查询 </el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      style="width: 100%"
      @selection-change="selectionChangeHandle"
    >
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50"
      />
      <el-table-column
        prop="name"
        header-align="center"
        align="center"
        label="冷柜名字"
      />
      <el-table-column
        prop="workTime"
        header-align="center"
        align="center"
        label="营业时间"
      />
      <el-table-column
        prop="shopsSn"
        header-align="center"
        align="center"
        label="冷柜编码"
      />
      <el-table-column
        prop="imgUrl"
        header-align="center"
        align="center"
        label="冷柜图片"
      >
        <template slot-scope="scope">
          <img
            v-if="scope.row.imgUrl"
            style="height: 30%; width: 30%"
            :src="scope.row.imgUrl"
            @click="openImg(scope.row.imgUrl)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="userId"
        header-align="center"
        align="center"
        label="冷柜管理员"
      >
        <template slot-scope="scope">
          <span>{{ transUser(scope.row.userId) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="longitude"
        header-align="center"
        align="center"
        label="经度"
      />
      <el-table-column
        prop="latitude"
        header-align="center"
        align="center"
        label="纬度"
      />
      <el-table-column
        show-tooltip-when-overflow
        prop="details"
        header-align="center"
        align="center"
        label="详细位置"
      />
      <el-table-column
        show-tooltip-when-overflow
        prop="telephone"
        header-align="center"
        align="center"
        label="联系电话"
      />
      <el-table-column
        prop="sort"
        header-align="center"
        align="center"
        label="排序"
      />
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="创建时间"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="180"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            v-if="isAuth('mall:shops:info')"
            type="text"
            size="small"
            @click="showDetails(scope.row.id)"
          >
            查看
          </el-button>
          <el-button
            v-if="isAuth('mall:shops:info')"
            type="text"
            size="small"
            @click="showCode(scope.row.id)"
          >
            开锁码
          </el-button>
          <el-button
            v-if="isAuth('mall:shops:myUpdate')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row.id)"
          >
            修改
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    />
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    />
    <shops-code-add-or-update
      v-if="shopsCodeAddOrUpdateVisible"
      ref="shopsCodeAddOrUpdate"
    />
  </div>
</template>

<script>
import AddOrUpdate from './myshop-add-or-update';
import ShopsCodeAddOrUpdate from './shopscode-add-or-update';

export default {
  components: {
    AddOrUpdate,
    ShopsCodeAddOrUpdate,
  },
  data() {
    return {
      searchForm: {
        name: '',
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListSelections: [],
      addOrUpdateVisible: false,
      shopsCodeAddOrUpdateVisible: false,
    };
  },
  activated() {
    this.getDataList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.$http({
        url: '/mall/shops/myShop',
        method: 'get',
        params: {
          page: this.pageIndex,
          limit: this.pageSize,
          name: this.searchForm.name,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.records;
          this.totalPage = data.page.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 查看详情
    showDetails(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, true);
      });
    },
    // 查看开锁码
    showCode(id) {
      this.shopsCodeAddOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.shopsCodeAddOrUpdate.init(id);
      });
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(id) {
      let ids = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.id;
          });
      this.$confirm(`确定对[id=${ids.join(',')}]进行[删除]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http({
            url: '/mall/shops/delete',
            method: 'post',
            data: ids,
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              });
              this.getDataList();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
